// JavaScript source code

$(document).ready(function () {

    // show/hide options when the 'main menu' button is clicked (only visable in mobile/tablet resolution - less than 992px)
    $('#tp-menu').click(function () {
        closeSubheadings();
        $('#header-navigation .mm-topbar').toggleClass('mm-show');
        $('#header-profileBlock').removeClass('active');
        $('#header-searchBlock').removeClass('active');
    });
    // show/hide search block on mobile
    $('#tp-search').click(function () {
        $('#header-searchBlock').toggleClass('active');
        $('#header-navigation .mm-topbar').removeClass('mm-show');
        $('#header-profileBlock').removeClass('active');
    });
    // show/hide profile menu on desktop
    $('#tp-profile-desktop').click(function (event) {
        $('#header-profileBlock').toggleClass('active');
        $('#header-profileBlock button > i').toggleClass('fa-times fa-user');
        changeTabIndex('#header-profileBlock');
        event.stopPropagation();
    });
    // show/hide contextual menu on desktop
    $('#section-menu-heading').click(function (event) {
        $('#section-menu-list').toggleClass('active');
        //$('#header-profileBlock button > i').toggleClass('fa-times fa-user');
        //changeTabIndex('#header-profileBlock');
        event.stopPropagation();
    });
    // show/hide
    $('#tp-profile-mobile').click(function () {
        //alert('mobile profile click');
        $('#header-profileBlock').toggleClass('active');
        $('#header-navigation .mm-topbar').removeClass('mm-show');
        $('#header-searchBlock').removeClass('active');
    });
    // click functionality for expanding the main menu options - closing any sibling menus as we go
    $('.mm-heading > button').click(function () {
        if ($(this).next('.mm-submenu').css('display') == 'none') {
            $(this).next('.mm-submenu').css('display', 'inline-block');
            $(this).closest('.mm-heading').siblings().find('.mm-submenu').css('display', 'none');
            $(this).closest('.mm-heading').siblings().find('button > i').removeClass('fa-caret-up').addClass('fa-caret-down');
        } else {
            $(this).next('.mm-submenu').css('display', 'none');
        }
        $(this).find('i').toggleClass('fa-caret-down fa-caret-up');
    });
    // selecting megamenu heading option with enter/space keys
    $('.mm-heading-link').keyup(function (e) {
        if (e.which == 13 || e.which == 32) {
            tabOpen(this);
        }
    });
    // selecting navigational option with enter/space keys
    $('.tabbed-link-option').keyup(function (e) {
        if (e.which === 13 || e.which === 32) {
            $(this)[0].click();
        }
    });
    // selecting context menu and its options with enter/space  
    $('#section-menu-heading').keyup(function (e) {
        if (e.which === 13 || e.which === 32) {
            $('#section-menu-list').toggleClass('active');
        }
    });
    // exiting navigation submenu with escape key
    $('#header-navigation nav').keyup(function (e) {
        if (e.which === 27) {
            tabClose();
        }
        e.stopPropagation(); // stops menu click acivating global close of menu                     
    });
    // exiting navigation submenu with escape key
    $(document).keyup(function (e) {
        if (e.which === 27 ) {
            tabClose();
        }
        e.stopPropagation(); // stops menu click acivating global close of menu                     
    });    
    // exiting profile bmenu with escape key
    $('#header-profileBlock').keyup(function (e) {
        if (e.which === 27) {
            tabClose();
        }
        e.stopPropagation(); // stops menu click activating global close of menu                     
    });
    // exiting contextual menu with escape key
    $('#sectional-menu').keyup(function (e) {
        if (e.which === 27) {
            tabClose();
        }
        e.stopPropagation(); // stops menu click acivating global close of menu                     
    });
    // close navigation or menu when click outside 
    $('html').click(function () {
        if ($(window).width() >= 992) {
            tabClose();       
        }
    });
    //
    // add new 'document ready' actions here...
});

// Cache the current window width
var cachedWidth = $(window).width();
$(window).resize(function () {
    // Create variable with new width
    var newWidth = $(window).width();
    // Check if widths are different (to prevent function being fired on scroll, due to show/hide scrollbar)
    if (newWidth !== cachedWidth) {
        closeSubheadings();
        tabClose();
    }
});

function closeSubheadings() {                               
    $('.mm-heading > button i').removeClass('fa-caret-up').addClass('fa-caret-down');
    $('.mm-heading .mm-submenu').css('display', '');
}

function tabOpen(thisElement, event) {   
    var objectHeader = $(thisElement).closest('.mm-heading');
    // if tab closed then open it
    if (objectHeader.attr('class').indexOf('active') > -1) {  
        objectHeader.children('a.mm-heading-link').trigger('click');
    // else if tab open then follow link
    } else {
        event.preventDefault();
        tabClose();
        objectHeader.addClass('active');
    }
}
function tabClose() {
  var submenus = $('.mm-submenu:visible');
  if( $(submenus).length > 0 ) {
    $('.mm-submenu:visible').hide().siblings('button').focus();
  } else {
    $('#menu-main-menu').removeClass('mm-show');
  }
  $('.mm-heading').removeClass('active');
  $('#header-profileBlock').removeClass('active');
  $('#header-profileBlock button > i').removeClass('fa-times').addClass('fa-user');
  changeTabIndex('#header-profileBlock');
  $('#section-menu-list').removeClass('active');
}
function changeTabIndex(objectID) {
    //alert('check Tab Index of ' + objectID);
    if ($(objectID).hasClass('active')) {
        $(objectID).children().find('a').attr('tabindex','0');
    } else  {
        $(objectID).children().find('a').attr('tabindex','-1');
    }
}



// WEBPACK FOOTER //
// ./scripts/cmi/menus.js